export const dateFiterChoice = [
  { key: "eq", text: "Is equal to" },
  { key: "ne", text: "Is not equal to" },
  { key: "gt", text: "Is greater than" },
  { key: "lt", text: "Is less than" },
];
export const numericFiterChoice = [
  { key: "ge", text: "Is greater than or equal to" },
  { key: "le", text: "Is less than or equal to" },
  { key: "eq", text: "Is equal to" },
  { key: "gt", text: "Is greater than" },
  { key: "lt", text: "Is less than" },
  { key: "ne", "text": "Does not equal", },
];
export const btnList = ["And", "Or"];

export const stringFilterChoice = [
  { "key": "Contains", "text": "Contains", type: "string" },
  { "key": "not contains", "text": "Not in / Does not contain", type: "string" },
  { "key": "eq", "text": "Exact Match", type: "string" },
  { "key": "eq null", "text": "Null or empty", type: "string" },
  { "key": "startswith", "text": "Starts with", type: "string" },
  { "key": "endswith", "text": "Ends with", type: "string" },
];

export const kowaFiterChoice = [
  { key: "true", text: "Yes" },
  { key: "false", text: "No" },
];
export const nullCheck = [
  { key: "eq", text: "Yes" },
  { key: "false", text: "No" },
];
